import React from "react";
import {
  Box,
  Typography,
  Chip,
  Paper,
  Stack,
} from "@mui/material";

const VendorPayoutStatus = ({data}) => {

  // ✅ Status UI Logic
  const getStatusChip = () => {
    if (!data?.is_submitted) {
      return <Chip label="Not Submitted" color="default" />;
    }

    if (data.approval_status === "pending") {
      return <Chip label="Pending Approval" color="warning" />;
    }

    if (data.approval_status === "approved") {
      return <Chip label="Approved" color="success" />;
    }

    if (data.approval_status === "rejected") {
      return <Chip label="Rejected" color="error" />;
    }
  };

  if (!data) return null;

  return (
    <Paper sx={{ p: 4,  mx: "auto" , mb:2}} >
      <Typography variant="h5" mb={2}>
        Payout Verification Status
      </Typography>

      <Stack spacing={2}>
        {/* Status */}
        <Box>
          <Typography variant="subtitle2">Current Status</Typography>
          {getStatusChip()}
        </Box>

        {/* Submitted */}
        {data.is_submitted && (
          <Box>
            <Typography variant="subtitle2">Submitted At</Typography>
            <Typography>
              {new Date(data.submitted_at).toLocaleString()}
            </Typography>
          </Box>
        )}

        {/* Approved */}
        {data.approval_status === "approved" && (
          <>
            <Box>
              <Typography variant="subtitle2">Approved At</Typography>
              <Typography>
                {new Date(data.approved_at).toLocaleString()}
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2">Verification</Typography>
              <Chip
                label={data.isVerified ? "Verified" : "Not Verified"}
                color={data.isVerified ? "success" : "default"}
              />
            </Box>
          </>
        )}

        {/* Rejected */}
        {data.approval_status === "rejected" && (
          <>
            <Box>
              <Typography variant="subtitle2">Rejected At</Typography>
              <Typography>
                {new Date(data.rejected_at).toLocaleString()}
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2">Reason</Typography>
              <Typography color="error">
                {data.rejection_reason || "No reason provided"}
              </Typography>
            </Box>
          </>
        )}
      </Stack>
    </Paper>
  );
};

export default VendorPayoutStatus;